import { render, staticRenderFns } from "./ModalMetasGatilho.vue?vue&type=template&id=bdadc3d2"
import script from "./ModalMetasGatilho.vue?vue&type=script&lang=js"
export * from "./ModalMetasGatilho.vue?vue&type=script&lang=js"
import style0 from "./ModalMetasGatilho.vue?vue&type=style&index=0&id=bdadc3d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports